/* @flow */

import {connect} from 'react-redux';
import TypeFieldComponent from './typeImpl';
import { ISO_ROLE_ADMINISTRATOR, ISO_ROLE_ACCOUNTANT } from 'constants/constants';

const mapStateToProps = (state, props) => ({
  ...props,
  isLoading: state.locale.genericDataIsLoading,
  values: props.isAdministrator || (props.hasProcurationUsers && props.hasProcurationGeneralConditions) ? state.locale.rolesForISOs :
          props.hasAdministratorRole ? state.locale.rolesForISOs.filter(r => r.id === ISO_ROLE_ACCOUNTANT || r.id === ISO_ROLE_ADMINISTRATOR) :
          props.hasProcuration ? state.locale.rolesForISOs.filter(r => r.id !== ISO_ROLE_ADMINISTRATOR) :
          state.locale.rolesForISOs.filter(r => r.id === ISO_ROLE_ACCOUNTANT)
});

export default connect(mapStateToProps)(TypeFieldComponent);
